import React from 'react';
import PropTypes from 'prop-types';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import Criterium from '@hydra/common/criterium/Criterium';

export const DomainRegistration = ({ criterium }) => {
  const { moment } = useI18n();
  if (!criterium.data) {
    criterium.data = {
      creation: null,
      expiration: null
    };
  }

  const { url, data } = criterium;
  const { creation, expiration } = data;
  const creationDate = creation && moment(new Date(creation.date)).fromNow();
  const expirationDate = expiration && moment(new Date(expiration.date)).fromNow();

  const content = (
    <>
      {
        creation
          ? <Translate component='p' content='domain_registration_creation' with={{ creationDate }} />
          : <Translate component='p' content='domain_registration_creation_ko' />
      }
      {
        expiration
          ? <Translate component='p' content='domain_registration_expiration' with={{ expirationDate }} />
          : <Translate component='p' content='domain_registration_expiration_ko' />
      }
    </>
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

DomainRegistration.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      creation: PropTypes.shape({
        date: PropTypes.number // date comes as seconds from epoch
      }),
      expiration: PropTypes.shape({
        date: PropTypes.number
      })
    })
  })
};

export default React.memo(DomainRegistration);
